module.exports = __webpack_public_path__ + "84ed4e52b4deecc86a558fd28a04521f.pdf";